import { useCallback } from 'react';

const CONTROL_BUTTONS_KEY = [
  'Enter',
  'Escape',
  'Tab',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
  'PageUp',
  'PageDown',
  'Backspace',
  'Delete',
  'Insert',
];

export const useBlockInvalidChar = (
  pattern: RegExp,
  excludedKeys: string[] = CONTROL_BUTTONS_KEY
) => {
  return useCallback(
    (event: React.KeyboardEvent<Element>) => {
      if (!pattern.test(event.key) && !excludedKeys.includes(event.key)) {
        event.preventDefault();
      }
    },
    [pattern, excludedKeys]
  );
};
